import React from 'react';

export interface TextProps {
	align?: 'left' | 'right' | 'center';
	bold?: boolean;
	color?: string;
	lineHeight?: number | string;
	lowercase?: boolean;
	size?: number;
	uppercase?: boolean;
}

export const styleFromTextProps = (props: TextProps) => {
	const style: React.CSSProperties = {
		color: props.color,
		fontSize: props.size,
		lineHeight: props.lineHeight,
		textAlign: props.align,
	};

	if (props.uppercase) {
		style.textTransform = 'uppercase';
	} else if (props.lowercase) {
		style.textTransform = 'lowercase';
	}

	if (props.bold) {
		style.fontWeight = 'bold';
	}

	return style;
};

export default (props: React.PropsWithChildren<TextProps & { style?: React.CSSProperties; }>) => {
	return (
		<span style={{ ...styleFromTextProps(props), ...props.style }}>
			{props.children}
		</span>
	);
};